// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"528f80af","977":"e3e8e26e"}[chunkId] + ".chunk.js";
};